var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.843 12.651c-1.392 0-2.521 1.129-2.521 2.521v6.306c0 1.392 1.129 2.521 2.521 2.521s2.521-1.129 2.521-2.521v-6.306c-.001-1.392-1.13-2.521-2.521-2.521z",
    fill: "#e91e63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.019 15.172c0 1.393 1.13 2.523 2.523 2.523s2.523-1.13 2.523-2.523v-2.523h-2.521c-.001 0-.001 0-.002 0-1.393 0-2.523 1.13-2.523 2.523z",
    fill: "#e91e63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.846-.001c-.001 0-.002 0-.003 0-1.393 0-2.523 1.13-2.523 2.523s1.13 2.523 2.523 2.523h2.521v-2.523c0-.001 0-.003 0-.005-.001-1.391-1.128-2.518-2.518-2.518z",
    fill: "#00bcd4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2.525 11.37h6.318c1.393 0 2.523-1.13 2.523-2.523s-1.13-2.523-2.523-2.523h-6.318c-1.393 0-2.523 1.13-2.523 2.523s1.13 2.523 2.523 2.523z",
    fill: "#00bcd4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.457 6.323c-1.391 0-2.518 1.127-2.518 2.518v.005 2.523h2.521c1.393 0 2.523-1.13 2.523-2.523s-1.13-2.523-2.523-2.523c-.001 0-.002 0-.003 0z",
    fill: "#4caf50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.641 2.522v6.325c0 1.392 1.129 2.521 2.521 2.521s2.521-1.129 2.521-2.521v-6.325c0-1.392-1.129-2.521-2.521-2.521-1.392 0-2.521 1.129-2.521 2.521z",
    fill: "#4caf50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff9800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.682 21.476c0-1.392-1.129-2.521-2.521-2.521h-2.521v2.523c.001 1.391 1.129 2.519 2.521 2.519s2.521-1.129 2.521-2.521z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.479 12.649h-6.318c-1.393 0-2.523 1.13-2.523 2.523s1.13 2.523 2.523 2.523h6.318c1.393 0 2.523-1.13 2.523-2.523s-1.13-2.523-2.523-2.523z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slackLogo.0b6bfe903e2a0f132a35bc6b4af39f6f.svg";
export { ForwardRef as ReactComponent };